define('extensions/i18n/defaultTags',{
    'a.close': '</a>',
    'div.open': '<div>',
    'div.close': '</div>',
    'span.close': '</span>'
});

